import { render, staticRenderFns } from "./SSelectClienteMaturation.vue?vue&type=template&id=5031fd4e"
import script from "./SSelectClienteMaturation.vue?vue&type=script&lang=js"
export * from "./SSelectClienteMaturation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports